module.exports = {
  SQUARE: "Square",
  CYLINDRICAL: "Cylindrical",
};
